<template>
  <div class="form-box">
    <Base-form-m ref="BaseFormM"
                 :form-items="formConfig"
                 :model-value.sync="formData"
                 submit-text="保存信息"
                 @submit="handleSubmit"
                 @failed="handleFailed">
      <!-- 自定义头像上传插槽 -->
      <template #avatar-upload="{ item }">
        <van-field :name="item.prop"
                   :label="item.label"
                   :rules="item.rules">
          <template #input>
            <van-uploader v-model="avatarFiles"
                          :max-count="1"
                          :after-read="afterRead" />
          </template>
        </van-field>
      </template>

      <!-- 提交按钮插槽 -->
      <template #actions>
        <van-button block
                    type="info"
                    native-type="submit">提交测试</van-button>
        <van-button block
                    type="default"
                    style="margin-top: 10px;"
                    @click.prevent="handleReseForm">重置表单</van-button>
      </template>
    </Base-form-m>

  </div>
</template>

<script>

export default {
  data() {
    return {
      avatarFiles: [],
      formData: {
        username: '',
        password: '',
        gender: 2,
        birthday: '1990-01-01', // 日期格式示例
        registerTime: '2023-01-01 08:30', // 日期时间格式示例
        workStartTime: '09:00', // 时间格式示例
        mobile: '',
        email: '',
        receiveNotifications: true,
        avatar: '',
        // 新增表单类型的数据
        agreeTerms: false, // 复选框
        interests: [], // 复选框组
        education: 1, // 单选框组
        age: 18, // 步进器
        satisfaction: 3, // 评分
        experience: 50 // 滑块
      },

      formConfig: [
        {
          prop: 'username',
          label: '用户名',
          type: 'text',
          placeholder: '请输入用户名',
          required: true,
          rules: [
            { required: true, message: '请输入用户名' },
            { min: 3, max: 12, message: '用户名长度在3-12个字符' }
          ],
          clearable: true,
          showItem: true, // 是否显示
          on: {
            input: this.handleChange
          }
        },
        {
          prop: 'password',
          label: '密码',
          type: 'password',
          placeholder: '请输入密码',
          required: true,
          rules: [
            { required: true, message: '请输入密码' },
            { pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,16}$/, message: '需包含大小写字母和数字，长度8-16位' }
          ]
        },
        {
          prop: 'gender',
          label: '性别',
          type: 'select',
          options: [
            { text: '男', value: 1 },
            { text: '女', value: 2 },
            { text: '保密', value: 0 }
          ],
          required: true,
          rules: [{ required: true, message: '请选择性别' }],
        },
        {
          prop: 'birthday',
          label: '出生日期',
          type: 'date',
          dateType: 'date',
          minDate: new Date(1900, 0, 1),
          maxDate: new Date(),
          required: true,
          rules: [{ required: true, message: '请选择出生日期' }]
        },
        {
          prop: 'registerTime',
          label: '注册时间',
          type: 'date',
          dateType: 'datetime',
          // minDate: new Date(2020, 0, 1),
          // maxDate: new Date(),
          required: true,
          rules: [{ required: true, message: '请选择注册时间' }]
        },
        {
          prop: 'workStartTime',
          label: '上班时间',
          type: 'date',
          dateType: 'time',
          required: true,
          rules: [{ required: true, message: '请选择上班时间' }]
        },
        {
          prop: 'mobile',
          label: '手机号',
          type: 'text',
          placeholder: '请输入手机号',
          required: true,
          rules: [
            { required: true, message: '请输入手机号' },
            { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确' }
          ],
          clearable: true,
          on: {
            input: this.handleChange
          }
        },
        {
          prop: 'email',
          label: '邮箱',
          type: 'text',
          placeholder: '请输入邮箱',
          required: true,
          rules: [
            { required: true, message: '请输入邮箱' },
            { pattern: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/, message: '邮箱格式不正确' }
          ],
          clearable: true
        },
        {
          prop: 'receiveNotifications',
          label: '接收通知',
          type: 'switch',
          required: false,
          rules: [],
          on: {
            change: this.handleChange
          }
        },
        {          
          prop: 'avatar',
          label: '头像',
          type: 'slot',
          slotName: 'avatar-upload',
          required: false,
          rules: [{ required: false, message: '请上传头像' }]
        },
        // 复选框
        {
          prop: 'agreeTerms',
          label: '协议',
          type: 'checkbox',
          checkboxLabel: '同意用户协议',
          required: true,
          rules: [{ required: true, message: '请同意用户协议' }],
          on: {
            change: this.handleChange
          }
        },
        // 复选框组
        {
          prop: 'interests',
          label: '兴趣爱好',
          type: 'checkbox-group',
          options: [
            { text: '阅读', value: 'reading' },
            { text: '音乐', value: 'music' },
            { text: '运动', value: 'sports' },
            { text: '旅行', value: 'travel' }
          ],
          optionProps: {
            id: "value",
            name: "text"
          },
          direction: 'horizontal',
          required: true,
          rules: [{ required: true, message: '请选择兴趣爱好' }],
          on: {
            change: this.handleChange
          }
        },
        // 单选框组
        {
          prop: 'education',
          label: '学历',
          type: 'radio-group',
          options: [
            { text: '高中', value: 1 },
            { text: '大专', value: 2 },
            { text: '本科', value: 3 },
            { text: '研究生', value: 4 }
          ],
          optionProps: {
            id: "value",
            name: "text"
          },
          direction: 'horizontal',
          required: true,
          rules: [{ required: true, message: '请选择学历' }],
          on: {
            change: this.handleChange
          }
        },
        // 步进器
        {
          prop: 'age',
          label: '年龄',
          type: 'stepper',
          min: 18,
          max: 100,
          step: 1,
          integer: true,
          required: true,
          rules: [{ required: true, message: '请设置年龄' }],
          on: {
            change: this.handleChange
          }
        },
        // 评分
        {
          prop: 'satisfaction',
          label: '满意度',
          type: 'rate',
          count: 5,
          required: true,
          rules: [{ required: true, message: '请评分' }],
          on: {
            change: this.handleChange
          }
        },
        // 滑块
        {
          prop: 'experience',
          label: '经验值',
          type: 'slider',
          min: 0,
          max: 100,
          step: 1,
          showValue: true,
          required: true,
          rules: [{ required: true, message: '请设置经验值' }],
          on: {
            change: this.handleChange
          }
        }
      ]
    };
  },

  methods: {
    handleChange(val) {
      console.log(val)
    },
    // 处理表单提交
    handleSubmit(formData, done) {
      console.log('表单提交数据:', formData);

      // 模拟API请求
      setTimeout(() => {
        this.$toast.success('用户信息保存成功');
        done(); // 调用done结束加载状态
      }, 1500);
    },

    // 处理表单验证失败
    handleFailed(errorInfo) {
      console.log('表单验证失败:', errorInfo);
      this.$toast.fail('请检查表单信息');
    },
    handleReseForm() {
      this.$refs.BaseFormM.resetForm();
    },
    // 头像上传处理
    afterRead(file) {
      // 模拟上传过程
      this.$toast.loading('上传中...');
      setTimeout(() => {
        this.$toast.clear();
        this.$toast.success('上传成功');
        this.formData.avatar = file.content;
      }, 1000);
    }
  }
};
</script>

<style lang="less" scoped>
.backgroundImage(@name) {
  background: url("~@/assets/images/@{name}") no-repeat;
  background-size: 100% 100%;
}

.form-box {
  padding: 10px;
}
</style>